module.exports = "/assets/landing-dw/how-it-works/step_2@2x.png?jV4gUjR";